import { createActionGroup, props } from "@ngrx/store";
import { Institute } from "src/app/model/institute.model";


export const InstituteActions = createActionGroup({
  source: 'Institute',
  events: {
    'Add Institute': props<{ institute: Institute }>(),
    'Load Institutes': props<{ filter: any, defaultParams: any }>(),
    'update Institute': props<{ institute: any }>()
  },
});

export const InstituteApiActions = createActionGroup({
  source: 'Institute API',
  events: {
    'Load Institutes Success': props<{ institutes: any }>(),
    'Load Institutes Failure': props<{ error: string }>(),
    'Update Institute Success': props<{ institute: any }>(),
  },
});